import React from "react";
import { Button, ButtonVariant, Tooltip } from "@merge-api/merge-javascript-shared";
import { ArrowLeftRight } from "lucide-react";
import { LinkedAccount } from "../../../../../../../models/Entities";
import { LinkedAccountStatuses } from "../../../../../../../constants";
import { API_TESTER_YOU_TO_MERGE_LINKED_ACCOUNT_PATH } from "../../../../../../../router/RouterUtils";
import { UserType } from "../../../../../../../models/Entities";
import useAppContext from "../../../../../../context/useAppContext";

type APITesterButtonProps = {
  linkedAccount: LinkedAccount;
};

const APITesterButton = ({ linkedAccount }: APITesterButtonProps) => {
  const { user } = useAppContext();
  const isMemberRole = user.type === UserType.member;
  const isIncomplete = linkedAccount?.status === LinkedAccountStatuses.INCOMPLETE;

  return (
    <Tooltip
      title={isIncomplete && "API tester is not available when the linked account is incomplete"}
    >
      <Button
        variant={ButtonVariant.TertiaryWhite}
        fullWidth
        disabled={isMemberRole || isIncomplete}
        leftIcon={<ArrowLeftRight size={12} />}
        onClick={() =>
          window.open(
            API_TESTER_YOU_TO_MERGE_LINKED_ACCOUNT_PATH + "?linked_account_id=" + linkedAccount.id,
            "_blank",
          )
        }
      >
        Send test API request
      </Button>
    </Tooltip>
  );
};

export default APITesterButton;
